import getLoyaltyBenefitAvailability from 'loyalty/lib/determineLoyaltyBenefitAvailability'
import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

const getLoyaltyStayUpgradeBenefitView = createSelector(
  getIsLoyaltyEnabled,
  (state: App.State) => state.loyalty.account.data?.benefits,
  (
    isLoyaltyEnabled,
    benefits,
  ): App.LoyaltyUserBenefitView | undefined => {
    if (!isLoyaltyEnabled) return
    const benefit = benefits?.find(benefit => benefit.code === 'hotel_upgrade')
    if (!benefit) return
    return {
      benefit,
      availability: getLoyaltyBenefitAvailability(benefit),
    }
  },
)

export default getLoyaltyStayUpgradeBenefitView
